import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Ertigaonrentinnavimumbai() {



  const cardData = {
    keyword: " Ertiga On Rent in Navi Mumbai ",


"headingDescription": "Royal Route Cab offers reliable Ertiga on rent in Navi Mumbai, providing comfortable, spacious, and budget-friendly travel solutions for families, corporate groups, airport transfers, and outstation journeys. Maruti Ertiga is a popular 7-seater MPV known for its excellent comfort, fuel efficiency, and smooth driving experience, making it ideal for both city and long-distance travel. Whether you need a local ride, Mumbai airport transfer, or a weekend trip, our well-maintained Ertiga ensures a stress-free and economical journey. With professional drivers, clean interiors, and flexible booking options like one-way, round trip, and full-day rental, Royal Route Cab is a trusted choice for Ertiga rental in Navi Mumbai with 24/7 availability and transparent pricing.",

"topPlaces": [
  {
    "title": "Ertiga On Rent in Navi Mumbai",
    "description": "Ertiga on rent in Navi Mumbai is a popular choice for families, small groups, and business travelers looking for a comfortable and budget-friendly travel option. It offers good seating capacity, fuel efficiency, and smooth performance for city and outstation travel."
  },
  {
    "title": "Navi Mumbai Ertiga Rental Service",
    "description": "Ertiga rental service in Navi Mumbai provides reliable transportation for airport transfers, family trips, corporate travel, and local sightseeing with professional drivers and comfortable seating."
  },
  {
    "title": "Ertiga with Driver Navi Mumbai",
    "description": "Ertiga with driver service in Navi Mumbai ensures a stress-free travel experience with trained chauffeurs. It is ideal for city rides, airport drops, and long-distance journeys."
  },
  {
    "title": "Airport Ertiga Cab Navi Mumbai",
    "description": "Airport Ertiga cab service in Navi Mumbai is widely used for pickup and drop services due to its spacious interiors and luggage capacity, ensuring a smooth travel experience for passengers."
  },
  {
    "title": "Family Ertiga Hire Navi Mumbai",
    "description": "Family Ertiga hire in Navi Mumbai is perfect for group travel, offering comfort, safety, and ample space for passengers during local and outstation trips."
  },
  {
    "title": "Corporate Ertiga Service Navi Mumbai",
    "description": "Corporate Ertiga service in Navi Mumbai is suitable for business professionals needing reliable transportation for meetings, office travel, and corporate events."
  },
  {
    "title": "Outstation Ertiga from Navi Mumbai",
    "description": "Outstation Ertiga from Navi Mumbai is commonly used for trips to nearby destinations like Pune, Lonavala, Nashik, and Shirdi, offering a comfortable and economical ride."
  },
  {
    "title": "Affordable Ertiga Rental Navi Mumbai",
    "description": "Affordable Ertiga rental in Navi Mumbai provides a cost-effective travel solution for families and small groups without compromising on comfort and convenience."
  },
  {
    "title": "Ertiga Airport Transfer Navi Mumbai",
    "description": "Ertiga airport transfer service in Navi Mumbai ensures timely pickup and drop with sufficient luggage space, making it ideal for smooth airport journeys."
  },
  {
    "title": "One Way Ertiga Cab Navi Mumbai",
    "description": "One way Ertiga cab service in Navi Mumbai is perfect for point-to-point travel, offering budget-friendly and convenient transportation for intercity and airport trips."
  }
],






services: [
  {
    name: "Ertiga on Rent in Navi Mumbai",
    description: "Ertiga on rent in Navi Mumbai offers spacious and comfortable travel for families and small groups. Ideal for local travel, airport transfers, and outstation trips, this vehicle provides excellent mileage and comfort. Professional drivers ensure safety. It guarantees a smooth and budget-friendly journey."
  },
  {
    name: "Ertiga Rental Navi Mumbai",
    description: "Ertiga rental Navi Mumbai provides flexible rental options for hourly, daily, and long-distance travel. Customers can choose plans based on their needs. Comfortable seating and ample space enhance travel experience. It ensures reliable transportation."
  },
  {
    name: "Ertiga Hire in Navi Mumbai",
    description: "Ertiga hire in Navi Mumbai offers affordable and convenient travel solutions for personal and business use. Ideal for city rides and intercity travel. Clean vehicles and trained drivers ensure comfort. It guarantees a pleasant journey."
  },
  {
    name: "Ertiga Car Rental Navi Mumbai",
    description: "Ertiga car rental Navi Mumbai provides a practical and economical option for group travel. Known for comfort and efficiency, it is suitable for all types of journeys. Flexible booking options enhance convenience. It ensures a smooth ride."
  },
  {
    name: "Ertiga Taxi Service Navi Mumbai",
    description: "Ertiga taxi service Navi Mumbai ensures dependable transportation with comfortable seating and professional drivers. Ideal for local travel, airport transfers, and outstation trips. It guarantees a reliable travel experience."
  },
  {
    name: "Book Ertiga on Rent in Navi Mumbai",
    description: "Book Ertiga on rent in Navi Mumbai with easy online booking and instant confirmation. Customers can select pickup location, timing, and travel plan. Transparent pricing ensures trust. It simplifies travel planning."
  },
  {
    name: "Best Ertiga on Rent Navi Mumbai",
    description: "Best Ertiga on rent Navi Mumbai ensures quality vehicles, professional drivers, and excellent service. This service focuses on comfort, safety, and punctuality. It guarantees a premium yet affordable travel experience."
  },
  {
    name: "Cheapest Ertiga Rental Navi Mumbai",
    description: "Cheapest Ertiga rental Navi Mumbai offers budget-friendly travel options without compromising comfort. Transparent pricing ensures no hidden charges. Ideal for cost-conscious travelers. It ensures economical travel."
  },
  {
    name: "Ertiga on Rent with Driver Navi Mumbai",
    description: "Ertiga on rent with driver Navi Mumbai provides stress-free travel with experienced chauffeurs. Ideal for long trips and city travel. Customers can enjoy comfortable rides without driving hassles. It ensures convenience and safety."
  },
  {
    name: "Ertiga Rental Service Navi Mumbai",
    description: "Ertiga rental service Navi Mumbai offers dependable travel solutions for local and outstation journeys. Well-maintained vehicles and trained drivers ensure comfort. It guarantees reliable transportation."
  },
  {
    name: "Ertiga Airport Pickup Navi Mumbai",
    description: "Ertiga airport pickup Navi Mumbai provides seamless pickup services from airport terminals. Spacious interiors make it ideal for luggage-heavy travel. Professional drivers ensure timely service. It guarantees a smooth transfer."
  },
  {
    name: "Ertiga Airport Drop Navi Mumbai",
    description: "Ertiga airport drop Navi Mumbai ensures timely transportation to the airport for departures. Comfortable vehicles enhance travel convenience. Ideal for families and business travelers. It guarantees stress-free travel."
  },
  {
    name: "Ertiga Outstation Rental Navi Mumbai",
    description: "Ertiga outstation rental Navi Mumbai is perfect for long-distance travel and intercity trips. Comfortable seating and fuel efficiency make it ideal for highways. Professional drivers ensure safety. It guarantees a smooth journey."
  },
  {
    name: "Ertiga Cab for Outstation Navi Mumbai",
    description: "Ertiga cab for outstation Navi Mumbai offers affordable travel for long-distance trips. Ideal for families and small groups. Clean vehicles and experienced drivers ensure comfort. It guarantees a pleasant travel experience."
  },
  {
    name: "24x7 Ertiga on Rent in Navi Mumbai",
    description: "24x7 Ertiga on rent in Navi Mumbai provides round-the-clock availability for all travel needs. Ideal for late-night and early-morning travel. Quick booking ensures convenience. It guarantees service anytime."
  },
  {
    name: "Late Night Ertiga Rental Navi Mumbai",
    description: "Late night Ertiga rental Navi Mumbai ensures safe and reliable travel during night hours. Professional drivers and secure rides enhance safety. Ideal for emergency and late-night travel. It guarantees peace of mind."
  },
  {
    name: "Ertiga on Rent in Mumbai",
    description: "Ertiga on rent in Mumbai offers comfortable and affordable travel for city and outstation journeys. Ideal for families and small groups. Professional drivers ensure safety. It guarantees a smooth ride."
  },
  {
    name: "Ertiga Car on Rent in Mumbai",
    description: "Ertiga car on rent in Mumbai provides practical and economical travel solutions. Suitable for daily use and long-distance trips. Comfortable interiors enhance experience. It ensures reliable travel."
  },
  {
    name: "Ertiga CNG on Rent in Mumbai",
    description: "Ertiga CNG on rent in Mumbai offers cost-effective travel with better fuel efficiency. Ideal for budget-conscious travelers. Clean vehicles ensure comfort. It guarantees economical journeys."
  },
  {
    name: "Ertiga on Hire in Mumbai",
    description: "Ertiga on hire in Mumbai provides flexible rental options for personal and business travel. Customers can choose hourly or outstation plans. Professional drivers ensure smooth rides. It guarantees convenience."
  },
  {
    name: "Ertiga Rent per KM in Mumbai",
    description: "Ertiga rent per km in Mumbai offers transparent pricing based on distance traveled. Customers can plan trips efficiently with clear cost structure. Ideal for long-distance travel. It ensures budget-friendly pricing."
  }
],

tableData: [
  ["Ertiga on Rent in Navi Mumbai", "Ertiga Rental Navi Mumbai"],
  ["Ertiga Hire in Navi Mumbai", "Ertiga Car Rental Navi Mumbai"],
  ["Ertiga Taxi Service Navi Mumbai", "Book Ertiga on Rent in Navi Mumbai"],
  ["Best Ertiga on Rent Navi Mumbai", "Cheapest Ertiga Rental Navi Mumbai"],
  ["Ertiga on Rent with Driver Navi Mumbai", "Ertiga Rental Service Navi Mumbai"],
  ["Ertiga Airport Pickup Navi Mumbai", "Ertiga Airport Drop Navi Mumbai"],
  ["Ertiga Outstation Rental Navi Mumbai", "Ertiga Cab for Outstation Navi Mumbai"],
  ["24x7 Ertiga on Rent in Navi Mumbai", "Late Night Ertiga Rental Navi Mumbai"],
  ["Ertiga on Rent in Mumbai", "Ertiga Car on Rent in Mumbai"],
  ["Ertiga CNG on Rent in Mumbai", "Ertiga on Hire in Mumbai"],
  ["Ertiga Rent per KM in Mumbai", ""]
],


whychoose: [
  {
    WhyChooseheading: "Affordable Ertiga on Rent in Navi Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers budget-friendly Ertiga rental in Navi Mumbai, perfect for family trips, airport transfers, and outstation travel."
  },
  {
    WhyChooseheading: "Spacious 6–7 Seater Family Car",
    WhyChoosedescription: "Maruti Ertiga provides comfortable seating for 6-7 passengers with ample legroom and luggage space, ideal for group travel."
  },
  {
    WhyChooseheading: "Low Per KM Pricing for Budget Travel",
    WhyChoosedescription: "Ertiga rental starts from approximately ₹14 to ₹17 per km, making it one of the most economical SUV options." 
  },
  {
    WhyChooseheading: "Affordable Daily Rental Packages",
    WhyChoosedescription: "Daily rental for Ertiga in Navi Mumbai typically ranges from ₹1200 to ₹2000 depending on season and provider." 
  },
  {
    WhyChooseheading: "Experienced & Professional Drivers",
    WhyChoosedescription: "Our drivers are well-trained and experienced in city and highway routes, ensuring safe and smooth travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including tolls and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Rental Availability",
    WhyChoosedescription: "Our Ertiga on rent service in Navi Mumbai operates round the clock for all travel needs."
  },
  {
    WhyChooseheading: "Trusted Budget SUV Rental Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for reliable Ertiga rental service in Navi Mumbai with clean vehicles and punctual drivers."
  }
]

};

const faqData = [
  { question: "What is the price of Ertiga on rent in Navi Mumbai?", answer: "Ertiga rental starts from ₹14–₹17 per km or ₹1200–₹2000 per day depending on package and duration." },
  { question: "How many passengers can travel in Ertiga?", answer: "Ertiga can comfortably seat 6 to 7 passengers." },
  { question: "Is Ertiga suitable for long-distance travel?", answer: "Yes, Ertiga is ideal for long-distance travel due to its comfort and mileage." },
  { question: "Do you provide driver with rental?", answer: "Yes, all Ertiga rentals include professional drivers." },
  { question: "Is rental available 24 hours?", answer: "Yes, our service operates 24/7." },
  { question: "Can I book for airport pickup?", answer: "Yes, we provide Navi Mumbai and Mumbai airport pickup and drop services." },
  { question: "Do you provide one-way booking?", answer: "Yes, both one-way and round-trip options are available." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for better availability." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly." },
  { question: "What is included in rental fare?", answer: "Fare usually includes driver charges, while toll and parking may be extra depending on package." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kiran Jadhav",
    feedback: "Ertiga on rent in Navi Mumbai with Royal Route Cabs was a great experience. The vehicle was spacious, clean, and perfect for our family trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Radhika Patil",
    feedback: "Very comfortable Ertiga rental service in Navi Mumbai. The car was well-maintained and the ride felt smooth and safe throughout the journey.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga on Rent in Navi Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/ertiga-on-rent-navi-mumbai.jpg", // replace if needed
  "description": "Book Ertiga on rent in Navi Mumbai with Royal Route Cabs for affordable, comfortable, and fuel-efficient travel. Ideal for airport transfers, family trips, outstation journeys, and corporate travel across Mumbai, Navi Mumbai, and nearby cities.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "11/km", // indicative rate (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/ertiga-on-rent-in-navi-mumbai"
  }
};





  return (
    <div>

<Helmet>
  <title>Ertiga on Rent in Navi Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Ertiga on rent in Navi Mumbai with Royal Route Cabs. Spacious 6–7 seater cab for airport, outstation, and local travel at affordable prices with 24x7 service."
  />

  <meta
    name="keywords"
    content="ertiga on rent in navi mumbai, ertiga rental navi mumbai, ertiga hire in navi mumbai, ertiga car rental navi mumbai, ertiga taxi service navi mumbai, book ertiga on rent in navi mumbai, best ertiga on rent navi mumbai, cheapest ertiga rental navi mumbai, ertiga on rent with driver navi mumbai, ertiga rental service navi mumbai, ertiga airport pickup navi mumbai, ertiga airport drop navi mumbai, ertiga outstation rental navi mumbai, ertiga cab for outstation navi mumbai, 24x7 ertiga on rent in navi mumbai, late night ertiga rental navi mumbai, ertiga on rent in mumbai, ertiga car on rent in mumbai, ertiga cng on rent in mumbai, ertiga on hire in mumbai, ertiga rent per km in mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/84.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ertigaonrentinnavimumbai;